import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import RigModal from 'components/modals/RigModal';
import { rigsColumns } from 'components/tables/RigTable';
import { GET_RIGS_QUERY } from 'services/api/rigs';
import { useQuery } from 'react-query';
import { useState, ChangeEvent, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import GTable from 'components/tables/GTable';
import { PERMISSIONS } from 'constants/permissions';
import { usePermissions } from 'hooks/usePermissions';
import LoadingPlaceholder from 'components/loading-placeholder/LoadingPlaceholder';

const Rig = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const {
    isLoading,
    isError,
    data: rig
  } = useQuery('get_rigs', GET_RIGS_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const [openJobStageModel, setOpenJobStageModel] = useState<boolean>(false);
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const [canCreateRig, canEditRig, canDeleteRig] = usePermissions([
    PERMISSIONS.JOB_CONFIGURATION.JOB_RIGS.CREATE,
    PERMISSIONS.JOB_CONFIGURATION.JOB_RIGS.UPDATE,
    PERMISSIONS.JOB_CONFIGURATION.JOB_RIGS.DELETE
  ]);

  const filteredRigs =
    rig?.data
      ?.sort((a: any, b: any) => {
        return (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      })
      .filter(rig => rig.name.toLowerCase().includes(searchTerm.toLowerCase()))
      .sort((a: any, b: any) => {
        return a?.name?.localeCompare(b?.name ?? '');
      }) ?? [];

  const columns = useMemo(
    () => rigsColumns(canEditRig, canDeleteRig),
    [canEditRig, canDeleteRig]
  );

  return (
    <div>
      <div className="mb-6">
        {isError && (
          <div className="alert alert-danger" role="alert">
            Error loading rigs
          </div>
        )}
        <h2 className="mb-4">All Rig</h2>
        <Row className="g-3 justify-content-between mb-4">
          {canCreateRig && (
            <Col xs="auto">
              <Button
                variant="primary"
                className="me-4"
                startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                onClick={() => setOpenJobStageModel(true)}
              >
                Create New Rig
              </Button>
              <RigModal
                show={openJobStageModel}
                handleClose={() => setOpenJobStageModel(false)}
              />
            </Col>
          )}
          <Col xs="auto">
            <div className="d-flex">
              <SearchBox
                placeholder="Search by rig name"
                className="me-2"
                onChange={handleSearchInputChange}
                value={searchTerm}
              />
            </div>
          </Col>
        </Row>

        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
          {isLoading ? (
            <LoadingPlaceholder />
          ) : (
            <GTable
              columns={columns}
              data={filteredRigs}
              isLoading={isLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Rig;
